import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { AnalyticsService } from '@services/analytics.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-cookie-consent',
  templateUrl: './cookie-consent.component.html',
  styleUrls: ['./cookie-consent.component.css'],
  standalone: false
})
export class CookieConsentComponent implements OnInit {
  public visible = false;

  constructor(
    private analytics: AnalyticsService,
    @Inject(PLATFORM_ID) private platformId: object
  ) {}

  ngOnInit() {
    this.visible = isPlatformBrowser(this.platformId) && environment.analyticsEnabled && !this.analytics.hasConsentDecision();
  }

  accept() {
    this.analytics.acceptCookies();
    this.visible = false;
  }

  reject() {
    this.analytics.rejectCookies();
    this.visible = false;
  }
}
